import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired, logout or refresh
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  googleLogin: (idToken) => api.post('/auth/google-login', { idToken }),
  setPassword: (newPassword) => api.post('/auth/set-password', { newPassword }),
  refreshToken: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
  getCurrentUser: () => api.get('/auth/me'),
};

// Maps API
export const mapsAPI = {
  getSpots: () => api.get('/maps/spots'),
  getSpotById: (id) => api.get(`/maps/spots/${id}`),
  getNearbySpots: (lat, lng, radius = 10000) => 
    api.get('/maps/spots/nearby', { params: { latitude: lat, longitude: lng, radiusInMeters: radius } }),
  createSpot: (data) => api.post('/maps/spots', data),
};

// Posts API
export const postsAPI = {
  getPostsByCampingSpot: (campingSpotId) => api.get(`/posts/camping-spot/${campingSpotId}`),
  getPostById: (id) => api.get(`/posts/${id}`),
  getTopPosts: () => api.get('/posts/top'),
  createPost: (data) => api.post('/posts', data),
  createComment: (data) => api.post('/posts/comments', data),
};

// Trips API
export const tripsAPI = {
  getPublicTrips: (skip = 0, take = 20) => api.get('/trips', { params: { skip, take } }),
  getMyTrips: () => api.get('/trips/my'),
  getTripById: (id) => api.get(`/trips/${id}`),
  createTrip: (data) => api.post('/trips', data),
  updateTrip: (id, data) => api.put(`/trips/${id}`, data),
  deleteTrip: (id) => api.delete(`/trips/${id}`),
  addPostToTrip: (id, data) => api.post(`/trips/${id}/posts`, data),
  removePostFromTrip: (id, postId) => api.delete(`/trips/${id}/posts/${postId}`),
};

export default api;
